import { growingTextArea, clearableInput, isMobile } from '../../utils/utils';
import { setUpFooter } from '../../components/footer';
import { checkHash, setUpHeader } from '../../components/header';
import { setUpWalkthrough } from '../../components/walkthrough';

import "normalize.css/normalize.css";
import "../../components/ukPopup/style.scss";
import "./style.scss";

import { inputFilter } from '../../utils/input';
import { initMap } from './geoMap';
import { embedAllTrack } from '../../utils/script';
import { initDataSearchBar, initEventSearchBar, resetData, search } from './searchBar';
import { initDataLanding, initEventLanding } from './landing';
import { initTradeAdvisory } from './tradeAdvisory';
import { LocalStorage } from '../../models/LocalStorage';
import { ROOT_GLOBAL } from '../../global/root';
import { setupUKPopup } from '../../components/ukPopup';
import { apiGetBannerOntop } from '../../utils/api';
import { Banner } from '../../models/Banner';
import { BannerHeader } from '../../components/BannerHeader';

const $ = window.$;
const ElementQueries = require('css-element-queries/src/ElementQueries');
window.page = 'homepage';
/** @type {Banner} */ let bannerHeader;

if (LocalStorage.isLoggedIn()) {
  window.location.href = ROOT_GLOBAL.USER_TRADE_ADVISORY + window.location.search
} else {
  $('body').removeClass('invisible');
}

embedAllTrack();

ElementQueries.listen();
inputFilter();

window.hsRev = "H5";
window.currentIndex = 0;
clearableInput();
initEvent();
initData();

function initEvent() {
  setUpHeader();
  setUpFooter();
  setUpWalkthrough(search);
  initEventSearchBar({ disableAutoComplete: true });
  initEventLanding();
  initTradeAdvisory();
  initMap();
  growingTextArea();
  $('textarea').autogrow();
  window.onpopstate = () => {
    reInitData();
  }
  setupUKPopup();
  // $('.product input.form-control').on('keyup', function (e) {
  //   window.searchData.product = $(this).val();
  //   checkSearchForm();
  //   const keycode = (e.keyCode ? e.keyCode : e.which);
  //   if (keycode === 13 && window.searchData.destination && (window.searchData.product || window.searchData.image)) {
  //     const list = $('.section-search .product .clearable .autocomplete-box .result-list li');
  //     list.each((index, element) => {
  //       if ($(element).attr("data-hs") === window.searchData.product) {
  //         window.searchData.hs = window.searchData.product;
  //       }
  //     });
  //     $('.section-search .product .clearable .autocomplete-box').hide();
  //     search(true, true);
  //   }
  // })
  setUpBannerOnTop();
  onResize();
}

function initData() {
  initDataSearchBar();
  initDataLanding();
  checkHash();
}

function reInitData() {
  resetData();
  initDataSearchBar(true);
}

function setUpBannerOnTop() {
  apiGetBannerOntop(
    function (data) {
      if (data?.data) {
        let bannerData = Banner.fromApiObject(data.data);
        bannerHeader = bannerData;
        fillDataBannerOnTop(bannerData);
      } else {
        $(".section.section-sales").addClass("hide")
      }
    },
    function (error) {
      $(".section.section-sales").addClass("hide")
    }
  )
}


/** @param {Banner} bannerData */
function fillDataBannerOnTop(bannerData) {
  if (!bannerData) return;
  $(`.section.section-sales .border-box .BannerHeader`).html("");
  let banners = bannerData.getActiveBanners();

  banners.forEach(banner => {
    let position = banner.position || "top";
    BannerHeader({
      parent: $(`.section.section-sales.${position}`),
      element: $(`.section.section-sales.${position} .border-box .BannerHeader`),
      banner: banner,
      hasAnimation: position === "top",
    })
  });
}


function onResize() {
  $(window).on('resize', () => {
    if (isMobile() && !window.isMobile) {
      window.isMobile = true;
      onReinstall();
    }
    if (!isMobile() && window.isMobile) {
      window.isMobile = false;
      onReinstall();
    }
  });
}

function onReinstall() {
  fillDataBannerOnTop(bannerHeader);
}